import { useMemo } from 'react'
import { byStartDateAsc, byStartDateDesc } from '../lib/utils'
import { isEventActive } from '../lib/formatDate'
import type { Event, EventAttendanceStatus } from '../types'
import { useMinuteNow } from './useMinuteNow'

/**
 * Splits a person's events by their status: upcoming going/interested (soonest
 * first) and past going — their history, latest first. "Going" to a past event
 * is intent, not proof of attendance, but it's the best signal we keep.
 */
export function useFilteredEventsByStatus(
  events: Event[],
  statuses: Map<string, EventAttendanceStatus>,
) {
  const now = useMinuteNow()

  return useMemo(() => {
    const goingEvents: Event[] = []
    const interestedEvents: Event[] = []
    const pastGoingEvents: Event[] = []
    for (const e of events) {
      const status = statuses.get(e.id)
      const active = isEventActive(e, now)
      if (status === 'going') (active ? goingEvents : pastGoingEvents).push(e)
      else if (status === 'interested' && active) interestedEvents.push(e)
    }
    goingEvents.sort(byStartDateAsc)
    interestedEvents.sort(byStartDateAsc)
    pastGoingEvents.sort(byStartDateDesc)
    return { goingEvents, interestedEvents, pastGoingEvents }
  }, [events, statuses, now])
}
